import styled from 'styled-components'

import { WithColor as WithColorUI } from '~ui'

export const WithColorInline = styled(WithColorUI)`
  display: inline;
`
